export function escapeCsvCell(value: unknown): string {
  if (value == null) return ''
  const s = String(value)
  if (/[",\n\r]/.test(s)) return `"${s.replace(/"/g, '""')}"`
  return s
}

export type CsvColumn<T> = {
  header: string
  value: (row: T) => unknown
}

function rowsToCsvMatrix(headers: string[], rows: unknown[][]): string {
  const lines = [headers.map(escapeCsvCell).join(',')]
  for (const row of rows) {
    lines.push(row.map(escapeCsvCell).join(','))
  }
  return `\uFEFF${lines.join('\r\n')}`
}

export function rowsToCsv(headers: string[], rows: unknown[][]): string
export function rowsToCsv<T>(rows: T[], columns: CsvColumn<T>[]): string
export function rowsToCsv<T>(
  arg1: string[] | T[],
  arg2: unknown[][] | CsvColumn<T>[],
): string {
  if (Array.isArray(arg1) && (arg1.length === 0 || typeof arg1[0] === 'string')) {
    return rowsToCsvMatrix(arg1 as string[], arg2 as unknown[][])
  }
  const rows = arg1 as T[]
  const columns = arg2 as CsvColumn<T>[]
  return rowsToCsvMatrix(
    columns.map((c) => c.header),
    rows.map((row) => columns.map((c) => c.value(row))),
  )
}

export function downloadCsv(filename: string, csv: string): void {
  const blob = new Blob([csv], { type: 'text/csv;charset=utf-8' })
  const url = URL.createObjectURL(blob)
  const anchor = document.createElement('a')
  anchor.href = url
  anchor.download = filename.endsWith('.csv') ? filename : `${filename}.csv`
  anchor.click()
  URL.revokeObjectURL(url)
}

export function exportTableCsv(filename: string, headers: string[], rows: unknown[][]): void {
  downloadCsv(filename, rowsToCsvMatrix(headers, rows))
}

export function objectsToCsv<T extends Record<string, unknown>>(
  headers: { key: keyof T; label: string }[],
  rows: T[],
): string {
  return rowsToCsvMatrix(
    headers.map((h) => h.label),
    rows.map((row) => headers.map((h) => row[h.key])),
  )
}

export function exportObjectsCsv<T extends Record<string, unknown>>(
  filename: string,
  headers: { key: keyof T; label: string }[],
  rows: T[],
): void {
  downloadCsv(filename, objectsToCsv(headers, rows))
}
